import React from 'react';
import { Sparkles, Cloud, Shirt, Lightbulb } from 'lucide-react';

const DestinationTips = ({ tips }) => {
  if (!tips || !tips.generated) return null;

  return (
    <div className="border-t border-[#E5E7EB] bg-[#F9F8F6] px-10 py-6" data-testid="destination-tips-section">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="h-4 w-4 text-[#D4AF37]" />
        <p className="uppercase text-[10px] tracking-[0.2em] text-[#6B7280] font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Destination Tips — AI Generated
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {tips.weather && (
          <div>
            <div className="flex items-center gap-1.5 mb-2">
              <Cloud className="h-3.5 w-3.5 text-[#2C3E35]" />
              <p className="text-xs font-semibold text-[#2C3E35] uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>Weather</p>
            </div>
            <p className="text-xs text-[#4B5563] leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif" }}>{tips.weather}</p>
          </div>
        )}

        {tips.packingTips && (
          <div>
            <div className="flex items-center gap-1.5 mb-2">
              <Shirt className="h-3.5 w-3.5 text-[#2C3E35]" />
              <p className="text-xs font-semibold text-[#2C3E35] uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>Packing Tips</p>
            </div>
            <div className="text-xs text-[#4B5563] leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {tips.packingTips}
            </div>
          </div>
        )}

        {tips.localTips && (
          <div>
            <div className="flex items-center gap-1.5 mb-2">
              <Lightbulb className="h-3.5 w-3.5 text-[#2C3E35]" />
              <p className="text-xs font-semibold text-[#2C3E35] uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>Local Tips</p>
            </div>
            <div className="text-xs text-[#4B5563] leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {tips.localTips}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DestinationTips;
